import useTranslation from 'next-translate/useTranslation';
import { IconWifiOff } from '@tabler/icons-react';

import { Button } from '~/domains/design-system/Button';
import { FullScreenMessage } from '~/domains/common/components/FullScreenMessage/FullScreenMessage';

type MyContestsConnectionErrorProps = {
  onRetry: () => void;
};

function MyContestsConnectionError({ onRetry }: MyContestsConnectionErrorProps) {
  const { t } = useTranslation('contest');

  return (
    <FullScreenMessage
      icon={<IconWifiOff />}
      title={t('myContests.states.error.connection.title')}
      subtitle={t('myContests.states.error.connection.subtitle')}
      actions={
        <Button size="medium" variant="secondary-fill" onClick={onRetry}>
          {t('myContests.states.error.connection.action')}
        </Button>
      }
    />
  );
}

export default MyContestsConnectionError;
